import { render } from "./TableUsuarios.vue?vue&type=template&id=3dd4bde6&scoped=true"
import script from "./TableUsuarios.vue?vue&type=script&lang=js"
export * from "./TableUsuarios.vue?vue&type=script&lang=js"

import "./TableUsuarios.vue?vue&type=style&index=0&id=3dd4bde6&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd4bde6"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QCheckbox,QInput,QIcon,QPagination});
